// @flow
export const TOGGLE_MENU = '@@navigation/TOGGLE_MENU'
